module.exports = __webpack_public_path__ + "static/media/map_icon_house.e229fcb0.png";